import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyboardUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="keyboard-up"><path d="M9.75 17.25H14.25M14 5L12 3L10 5M5.75 12.75H5.76V12.76H5.75V12.75ZM9.75 12.75H9.76V12.76H9.75V12.75ZM14.25 12.75H14.26V12.76H14.25V12.75ZM5.75 17.25H5.76V17.26H5.75V17.25ZM18.25 12.75H18.26V12.76H18.25V12.75ZM18.25 17.25H18.26V17.26H18.25V17.25ZM1.75 8.75H22.25V21.25H1.75V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconKeyboardUp;
